import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { BackButton } from '@/components';
import { SourceView } from '@/features/SourceView';
import { EventFeed } from '@/features/EventFeed';
import { useDocumentTitle, usePlayerStateReporter } from '@/hooks';
import { FullSource, SourceType } from '@/types/source';

export default function SourcePage() {
    const { sourceId } = useParams<{ sourceId: string }>();
    const [sourceName, setSourceName] = useState<string | undefined>();
    const [isLive, setIsLive] = useState(true);

    const { onTimeUpdate, onPlayingChange, onLoopChange, onSeeked } =
        usePlayerStateReporter({
            isLive,
        });

    useDocumentTitle('source', sourceName);

    const onSourceLoaded = useCallback((source: FullSource) => {
        setIsLive(source.type === SourceType.CAMERA);
        setSourceName(source.displayName);
    }, []);

    if (!sourceId) {
        return <div className="p-8 text-red-400">Source ID not provided</div>;
    }

    return (
        <div className="h-full relative">
            <EventFeed context={{ type: 'sourceAlerts', sourceId }} />
            <BackButton variant="floating" />

            <div className="h-full overflow-y-auto px-4 panels:px-8">
                <div className="h-full flex flex-col items-center">
                    <div className="w-full flex-1 min-h-0">
                        <SourceView
                            sourceId={sourceId}
                            onTimeUpdate={onTimeUpdate}
                            onPlayingChange={onPlayingChange}
                            onLoopChange={onLoopChange}
                            onSeeked={onSeeked}
                            onSourceLoaded={onSourceLoaded}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
